package com.essntl.features.area.domain.model

import com.essntl.features.country.domain.model.CountryModel

data class AreaModel(
    val id: String,
    val name: String?,
    val createdAt: String,
    val countryModel: CountryModel?,
) {
    fun getChangedFields(area: AreaModel) =
        AreaModel(
            id = id,
            createdAt = createdAt,
            name = if (name?.lowercase()?.capitalize() != area.name?.lowercase()?.capitalize()) area.name else null,
            countryModel = if (countryModel != area.countryModel) area.countryModel else null,
        )

    val isEmpty
        get() = this.copy(id = "", createdAt = "") == empty

    companion object {
        val empty =
            AreaModel(
                id = "",
                createdAt = "",
                name = null,
                countryModel = null,
            )
    }
}
